import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import LandingPage from './pages/LandingPage'
import About from './pages/About'
import Contact from './pages/Contact'
import Product from './pages/Product'

export default function RouterContainer() {
    return (
        <BrowserRouter>

            <Routes>

                <Route path='/' element={<LandingPage />} />
                <Route path='/about' element={<About />} />
                <Route path='/contact' element={<Contact />} />
                <Route path='/products' element={<Product />} />
            </Routes>
        </BrowserRouter>
    )
}
